import { render, staticRenderFns } from "./CopyCommissionsForm.vue?vue&type=template&id=7cb147e6&scoped=true&"
import script from "./CopyCommissionsForm.vue?vue&type=script&lang=js&"
export * from "./CopyCommissionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb147e6",
  null
  
)

export default component.exports